import { render, staticRenderFns } from "./formSubmit.vue?vue&type=template&id=23974f80&"
import script from "./formSubmit.vue?vue&type=script&lang=js&"
export * from "./formSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports